module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, undefined) {

	var _ = {
		initCollection: function () {
			this.dataModel = [];
			this.dataModelLastUpdate = [];
			this.idStart = 1;

			_.updateCollection.call(this, {method: 'add', data: this.getOption('collection') || []});
		},

		transformToDataModel: function (c) {
			var getModObject;

			getModObject = function (data, _id) {
				var
					object = {};

				object.value = data;

				Object.defineProperty(object, '_id', {
					enumerable: true,
					configurable: false,
					writable: false,
					value: _id
				});

				return object;
			};

			if (fox.isArray(c)) {
				return c.map(function (v) {
					return getModObject(v, this.idStart++);
				}, this);
			} else if (fox.isObject(c)) {
				return getModObject(c, this.idStart++);
			} else {
				return getModObject({v: c}, this.idStart++);
			}
		},

		getNodeByItem: function (id) {
			var item;

			item = this.dataModel[id];

			return item &&
				item._domNode &&
					item._domNode.filter(function (el) {return el.nodeType === 1;}) || false;
		},

		setLastDataModel: function (data) {
			this.dataModelLastUpdate = data;
		},

		updateCollection: function (params) {
			var
				method = params.method,
				data = params.data,
				position = params.position,
				id = params.id,
				dm
			;

			switch (method) {
				case 'add':
					position = position === undefined ? 'bottom' : position;

					if (fox.isArray(data)) {
						dm = _.transformToDataModel.call(this, data);

						if (this.dataModel.length === 0) {
							this.dataModel = dm;
						} else {
							if (position === 'top') {
								this.dataModel = dm.concat(this.dataModel);
							} else if (fox.isNumeric(position)) {
								var a, b;

								b = this.dataModel.slice(position);
								a = this.dataModel.slice(0, position);

								this.dataModel = a.concat(dm.concat(b));
							} else {
								this.dataModel = this.dataModel.concat(dm);
							}
						}
					} else {
						dm = _.transformToDataModel.call(this, data);

						if (this.dataModel.length === 0) {
							this.dataModel = [dm];
						} else {
							if (fox.isNumeric(position)) {
								this.dataModel.splice(position, 0, dm);
							} else {
								this.dataModel[position === 'top' ? 'unshift' : 'push'](dm);
							}
						}
					}

					_.setLastDataModel.call(this, this.isEmbedded() === true ? fox.isArray(dm) ? dm : [dm] : this.dataModel);

					return this.dataModelLastUpdate.map(function (v) {
						return v._id;
					});
				case 'update':
					if (id !== undefined) {
						var item = this.dataModel[id];

						if (item && this._active) {
							item.value = data;

							_.setLastDataModel.call(this, [item]);
						} else {
							_.setLastDataModel.call(this, this.dataModel);
						}
					} else {}

					break;
				case 'remove':
					if (id !== undefined) {
						var item = this.dataModel[id];

						if (item) {
							if (item._domNode && item._domNode.length) {
								for (var i = item._domNode.length; i--;) {
									if (item._domNode[i].parentNode) {
										item._domNode[i].parentNode.removeChild(item._domNode[i]);
									}
								}
							}

							this.dataModel.splice(id, 1);
						}
					} else {
						this.dataModel = [];
						_.setLastDataModel([]);

						this.removeFromDom();
					}

					break;
			}
		},

		resetState: function () {
			this.setOption('embed.location', 'inside');
			_.setLastDataModel.call(this, this.dataModel);
		},

		cleanDomReference: function () {
			fox.each(this.dataModel, function (v) {
				v._domNode = null;
			});
		},

		render: function (location) {
			return this.setOption('embed.location', location || 'inside').render();
		}
	};

	fox.registerWidget('AdvancedList', {
		init: function () {
			if (fox.oop.instanceOf(this.getParent(), 'Grid') && !this.getOption('notOverrideListBehavior')) {
				this.dl = this.getParent().dl;
				
				if (this.dl) {
					this.handleEvent(this.dl, 'loaded', fox.bind(this._dlLoaded, this), {
						'listenHistory': true,
						prefix: 'gridAdvancedListInit'
					});
				}
			}

			_.initCollection.call(this);

			this.callParent('init', arguments);
		},

		running: function () {
			this.callParent('running', arguments);

			var container = this.getOption('embed.container') || this.getOption('container');
			var embedWidget = this.wom1(this.getOption('embed.widget'));

			if (embedWidget && fox.oop.instanceOf(embedWidget, 'Widget')) {
				var containerNode = embedWidget.dom1(container);

				if (containerNode && containerNode.childNodes.length) {
					containerNode.innerHTML = '';
				}
			}
		},

		resetCollection: function (c) {
			this.remove();

			if (c !== undefined) {
				this.appendItem(c);
			}
		},

		setCollection: function (c) {
			this.resetCollection(c);
		},

		appendItem: function (item, skipRender) {
			var ids = _.updateCollection.call(this, {method: 'add', data: item});

			if (skipRender !== true) {
				_.render.call(this, 'lastChild');
			}

			return ids;
		},

		prependItem: function (item, skipRender) {
			var ids = _.updateCollection.call(this, {method: 'add', data: item, position: 'top'});

			if (skipRender !== true) {
				_.render.call(this, 'firstChild');
			}

			return ids;
		},

		appendItemBefore: function (item, itemIndx, skipRender) {
			itemIndx = itemIndx - 1;

			this._referenceNodes = _.getNodeByItem.call(this, itemIndx);
			var ids = _.updateCollection.call(this, {method: 'add', data: item, position: itemIndx});

			if (skipRender !== true) {
				_.render.call(this, 'insertBefore');
			}

			return ids;
		},

		updateItem: function (item, itemIndx, skipRender) {
			itemIndx = itemIndx - 1;

			_.updateCollection.call(this, {method: 'update', data: item, id: itemIndx});

			this._referenceNodes = _.getNodeByItem.call(this, itemIndx);

			return skipRender !== true && _.render.call(this, 'replace');
		},

		remove: function (itemIndx) {
			if (itemIndx === undefined) {
				_.updateCollection.call(this, {method: 'remove'});
			} else if (fox.isArray(itemIndx)) {
				fox.each(itemIndx, function (id) {
					_.updateCollection.call(this, {method: 'remove', id: id - 1});
				}, this);
			} else {
				_.updateCollection.call(this, {method: 'remove', id: itemIndx - 1});
			}
		},
		
		embedding: function() {
            if (!this.skipRender()) {
                this.element = [];
            }

            var containers = fox.dom.select(this.requireOption('embed.container'), this.visualParent.element);

            fox.each(containers, function(container) {
                if (!this._rendered) {
                    this._render(true);
                }
                if (this.getOption('embed.location') === 'inside') {
                    container.setAttribute('data-widget-alias', this.getAlias());
                    container.setAttribute('data-widget-class', this.getClass());
                    container.setAttribute('data-widget-id', this.getId());
                }
                if (!this.skipRender()) {
                    this.hookWrapper('embedToDom', container);
                }
                this._rendered = false;
            }, this);
        },

		embedToDom: function (container) {
			this.callParent('embedToDom', arguments);
			var fragment = this.fragment;

			switch (this.getOption('embed.location')) {
				case 'lastChild':
				case 'firstChild':
					this.element = [container];
				break;
				case 'replace':
					var repEl = Array.prototype.filter.call(fragment.childNodes, function (n) {return n.nodeType === 1;});

					if (repEl.length && this._referenceNodes.length) {
						for (var i = this._referenceNodes.length - 1; i >= 0; i--) {
							container.replaceChild(repEl[i], this._referenceNodes[i]);
						}

						this.element.unshift(container);
					}

					this._referenceNodes = null;
				break;
				case 'insertBefore':
					var i;

					if (this._referenceNodes.length) {
						while (i = fragment.childNodes.length) {
							container.insertBefore(fragment.childNodes.item(i - 1), this._referenceNodes[0]);
						}

						this.element.unshift(container);
					}

					this._referenceNodes = null;
				break;
			}
		},

		afterEmbed: function () {
			this.callParent('afterEmbed', arguments);

			_.resetState.call(this);
		},

		removeFromDom: function () {
			this.callParent('removeFromDom', arguments);

			_.resetState.call(this);
		},

		deactivate: function () {
			_.cleanDomReference.call(this);

			this.callParent('deactivate', arguments);
		},

		rendering: function () {
			var insb = this.getOption('embed.location') === 'insertBefore';
			var templater = this.getTemplater(this.getOption('tpl.row'));
			var fragment = document.createDocumentFragment();
			var dl = fox.createDl();
			var dmlup = insb ? this.dataModelLastUpdate.reverse() : this.dataModelLastUpdate;
			var tplo = this.getTemplateOptions();

			fox.each(dmlup, function (v) {
				var i;
				var rowNode;
				var collectionRow = fox.mixin(v.value, tplo, {
					_id: v._id
				});

				dl.setCollection([collectionRow]);
				rowNode = templater.setData(dl).compile();

				v._domNode = [];

				while ((i = rowNode.childNodes.length)) {
					var node = rowNode.childNodes.item(insb ? i - 1 : 0);

					fragment.appendChild(node);
					v._domNode.push(node);
				}
			});

			this.fragment = fragment;
		},

		getLength: function () {
			return this.dataModel.length;
		},

		getRowNode: function (itemIndx) {
			return _.getNodeByItem.call(this, itemIndx - 1);
		},

		getDataById: function (id) {
			var
				data,
				indx,
				j = this.getLength()
			;

			for (var i = 0; i < j; i++) {
				if (this.dataModel[i]._id === Number(id)) {
					return {
						data: this.dataModel[i].value,
						indx: i + 1
					};
				}
			}

			return false;
		},

		getIndexByModel: function (model) {
			var indx = this.dataModel.indexOf(model);

			return indx !== -1 ? indx + 1 : false;
		},

		filter: function () {
			var
				arg1,
				arg2,
				_filter,
				buff = []
			;

			_filter = function (field, value) {
				return this.dataModel.filter(function (v) {
					var itemData = v.value;

					return itemData[field] && value.indexOf(itemData[field]) !== -1;
				});
			};

			if (arguments.length === 1) {
				arg1 = arguments[0];

				if (fox.isObject(arg1) && arg1.field !== undefined) {
					if (arg1.value !== undefined && !fox.isArray(arg1.value)) {
						arg1.value = [arg1.value];
					}

					return _filter.call(this, arg1.field, arg1.value);
				} else if (fox.isArray(arg1)) {
					for (var i = 0; i < arg1.length; i++) {
						if (arg1[i].field !== undefined) {
							if (!fox.isArray(arg1[i].value)) {
								arg1[i].value = [arg1[i].value];
							}

							buff.concat(_filter.call(this, arg1[i].field, arg1[i].value));
						}
					}

					return buff;
				}
			} else if (arguments.length === 2) {
				arg1 = arguments[0];
				arg2 = fox.isArray(arguments[1]) ? arguments[1] : [arguments[1]];

				return _filter.call(this, arg1, arg2);
			}
		},

		getOriginalData: function () {
			return this.dataModel.map(function (dataItem) {
				return dataItem.value;
			});
		},

		_dlLoaded: function (obj, dl, e) {
			this.setCollection(dl.getCollection());
		}
	});

})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/list/advancedList.js
// module id = 205
// module chunks = 0